import request from '@/axios'

// F-01-服务人员信息
export function getStaffInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff/getStaffInfo',
    method: 'post',
    data
  })
}

// F-02-服务人员打分
export function addComments(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/comments/addComments',
    method: 'post',
    data
  })
}

// 服务人员打分选项
export function getScoreLabels(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/feedback/getScoreLabels',
    method: 'post',
    data
  })
}

// F-05-反馈订单列表
export function getFeedbackOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getFeedbackOrderList',
    method: 'post',
    data
  })
}

// F-06-反馈订单问题列表
export function getComplaintList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintList',
    method: 'post',
    data
  })
}

// F-07-问题处理详情
export function getComplaintInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintInfo',
    method: 'post',
    data
  })
}

// F-08-客诉处理
export function dealComplaint(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/dealComplaint',
    method: 'post',
    data
  })
}

// 问题选项
export function getFields(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/feedback/getFields',
    method: 'post',
    data
  })
}

// F-04-客户问题反馈
export function addComplaint(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/complaint/addComplaint',
    method: 'post',
    data
  })
}

// 问题分类列表
export function getCategoryList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/feedback/getCategoryList',
    method: 'post',
    data
  })
}
